<template>
  <v-dialog :value="value" max-width="500" @click:outside="close">
    <v-card>
      <v-card-title>オルソ画像再構築</v-card-title>
      <v-card-text>
        カスタムのパラメータでオルソ画像を再構築します。再構築する画像種類を選択してください。
        <div>
          <v-checkbox
              v-show="folderColorTypes.includes('thermal')"
              value="thermal"
              v-model="selected"
              label="サーモオルソ画像"
              dense
              hide-details
          ></v-checkbox>
          <v-checkbox
              v-show="folderColorTypes.includes('color')"
              value="color"
              v-model="selected"
              label="可視オルソ画像"
              dense
              hide-details
          ></v-checkbox>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" depressed>キャンセル</v-btn>
        <v-btn @click="rerunODM" color="primary" :disabled="selected.length === 0">再構築</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "ODMRerunDialog",
  props: ['value', 'folderId'],
  data(){
    return {
      folderColorTypes: [],
      selected: []
    }
  },

  methods: {
    close(){
      this.$emit('input');
    },
    rerunODM(){
      this.axios
          .post('/api/folder/rerun-odm/' + this.folderId, {color_types: this.selected})
          .then(() => {
            this.close();
            store.showSuccessDialog('再構築のリクエストを受けました。再構築完了後、メール通知するので少々お待ちください。')
          })
          .catch(() => {
            store.showErrorDialog('再構築の受付にてエラーが起きました。再度試してください。')
          })
    }
  },

  created() {
    this.axios
        .get('/api/folder/color-types/' + this.folderId)
        .then((response) => {
          this.folderColorTypes = response.data;
        })
        .catch(() => {
          store.showErrorDialog('フォルダーの情報を取得できませんでした。再度試してください。');
        })
  }
}
</script>

<style scoped>

</style>
